/**
 * Submit ACUL no estilo FormHandler do @auth0/auth0-acul-js —
 * não depende do construtor da screen class (evita falha silenciosa no IIFE).
 */
import type { TransactionErrorLike } from './transactionError'

type UlContext = {
  screen?: {
    name?: string
    data?: { email?: string; phoneNumber?: string; phone_number?: string }
    texts?: Record<string, string>
    links?: Record<string, string> | null
  }
  transaction?: { state?: string; errors?: TransactionErrorLike[] | null }
}

export function getUlContext(): UlContext | null {
  const ctx = (
    window as Window & { universal_login_context?: UlContext }
  ).universal_login_context
  return ctx ?? null
}

export function submitUlForm(
  fields: Record<string, string | number | boolean | undefined>,
): void {
  const state = getUlContext()?.transaction?.state
  if (!state) {
    throw new Error('UL_STATE_MISSING')
  }

  const form = document.createElement('form')
  form.method = 'POST'
  form.action = ''

  const payload: Record<string, string> = {
    state,
    ...Object.fromEntries(
      Object.entries(fields)
        .filter(([, v]) => v !== undefined)
        .map(([k, v]) => [k, String(v)]),
    ),
  }

  for (const [name, value] of Object.entries(payload)) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  }

  const sdk = document.createElement('input')
  sdk.type = 'hidden'
  sdk.name = 'acul-sdk'
  sdk.value = '@auth0/auth0-acul-js@1.6.0'
  form.appendChild(sdk)

  document.body.appendChild(form)
  form.submit()
}
